import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=4fbdb824&scoped=true"
var script = {}
import style0 from "./Title.vue?vue&type=style&index=0&id=4fbdb824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbdb824",
  null
  
)

export default component.exports